module.exports = __webpack_public_path__ + "static/accountants-hero-75c6873585b383860cd871460e520ef7.png";